/*** IMPORTS FROM imports-loader ***/
(function() {

define(['jquery', 'pip-model', 'pip-media-manager', 'account.list','window'], function ($, pip, mediaManager, myList, window) {
       return {
            init: function() {
               $(window.document).off('click.myList').on('click.myList', '#saveToList', function(e) {                     
                    e.stopPropagation();
                    var config = {
                        source: 'pip',
                        isMobileChannel: pip.platform === "MOBILE",
                        $trigger: $(this),
                        item: {
                            itemId: pip.products.primary.data.itemId,
                            quantity: pip.customer.quantity,
                            imageURL: mediaManager.getMedia('image').url_100,
                            price: (pip.products.primary.data.storeSkus[0].pricing && pip.products.primary.data.storeSkus[0].pricing.specialPrice) ? pip.products.primary.data.storeSkus[0].pricing.specialPrice : null
                        }                    
                    };                         
                    myList.saveToList(config);
                });
                } 
        };
    
    });
    

}.call(window));